import { ProfileService } from './../../services/profile.services';
import { AppConfiguration } from './../conf/app.configuration';
import {
  Component,
  OnDestroy,
  ElementRef,
  Optional,
  OnInit,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { PlycaDataService } from '../../services/plyca.service';
import { PaginationInfo, PaginationDTO } from '../api/PaginationModel';
import {
  DocumentDTO,
  Link,
  getSimpleIdentifierFromString,
  DOCUMENT_SELECTION_MODE,
  DivisionDTO
} from '../api/plyca-dtos';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceLocator } from '../ServiceLocator';
import { UserService } from '../user.service';
import { UIService, generateRandomIdentifier } from '../ui.service';
import * as objectPath from 'object-path';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { UserPrefs, DocumentsViewPrefs, DossierDocumentsPrefs } from '../api/UserPrefs-dto';
import { SET_USERPREFS } from '../store/userPrefs';
import {
  Observable,
  forkJoin,
  of
} from '../../../node_modules/rxjs';
import { ConfirmationService, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

import { newTemplateComponent } from './newTemplate/newTemplate.component';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { Configuration } from '../conf/app.constants';
import { catchError, debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { procedureComponent } from '../dossiers/procedures/procedure.component';
import { DocumentService } from './document.service';
import { documentViewerComponent } from './documentViewer/documentViewer.component';
import { PropertyService } from '../properties/property.service';
import { LongTextDTOModal, LongTextEditorComponent } from '../components/forms/longTextEditor.component';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { exportProcessEditionPanelComponent } from '../admin/exportProcessPanel/exportProcessEditionPanel.component';
import { ActionDefinitionDTO, ExportDocumentDTO, ExportProcessDTO, ExportProcessResources, ExportProjectEntityDTO }
  from '../api/plyca-dtos-v2';
import { DatePipe, formatDate } from '@angular/common';
import { DossierService } from '../dossiers/dossier.service';
import { FormConfig } from '../components/forms/form.objects';
import { formPlycaComponent } from '../components/forms/formPlyca.component';
import { HttpParams } from '@angular/common/http';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import * as lodash from 'lodash';
import { DATEPIPE_DATETIME_FORMAT, DATEPIPE_DATE_FORMAT } from '../../services/language.service';
import { UserPrefsService } from '../store/user-prefs.service';
import { MANUALPROCESSINGMODE_ID, ProcedureCircuitComponent } from '../dossiers/procedures/procedureCircuit.component';
import { ActionsProcessComponent } from '../actions/actions.process.component';
import { tenderViewComponent } from '../dossiers/tenderView/tenderView.component';


// TODO: Que funcione dossierdetail
// TODO: Elemento filtro y gráficas, serachsettings
@Component({
  selector: 'documents',
  templateUrl: 'documents.template.html',
  providers: [DialogService, DatePipe]
})
export class documentsComponent extends BaseComponent implements OnDestroy, OnInit, AfterViewInit {

  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;
  public DATEPIPE_DATETIME_FORMAT = DATEPIPE_DATETIME_FORMAT;
  MIN_SEARCH_TEXT_LENGHT = 3;

  private dossierId = 'Sin Información';
  documentId;
  relatedDoc;
  isRelatedDocsMode = false;
  public docFilters: any;


  dossier: any;

  showHeader = true;

  documents: any[];

  filteredDocuments: any[];
  filterText = '';

  // documentsLoaded = false;
  dossierLoaded = false;
  /* FILTROS */
  pagInfo: PaginationInfo;
  pagLinks: Link[];
  //  _filters: any = {};
  // editing = true;

  activeGroups: Array<number>;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  private userPrefs: UserPrefs;

  public isModalWindow = false;
  public windowHash: string;
  public filterWindowHash: string;

  groupedDocuments: any[];
  selectedNodes: any[] = [];

  createModel = false;

  // apertura en modo buscador para seleccionar un documento
  // public selectionMode = true;
  // EXPORTACIONES: Modo pantalla para selección múltiple de documentos (habilita checks a la izda de cada document)
  // public EXPORT_MODE = false;
  public SELECTION_MODE = 0;
  selectedDocs: Array<any>;
  selectedDocsReadOnly = false;
  // public SELECTION_MODE_OFF = 0;
  // public SELECTION_MODE_SINGLE_SELECTION = 1;
  // public SELECTION_MODE_MULTIPLE_SELECTION = 2;

  ignoreNotificationsDefault = false;


  groupsBy: Array<any> = [
    {
      id: 1,
      description: 'División',
      tooltip: 'División',
      img: 'fa-folder',
      field: 'entity.division.name',
      sortField: 'entity.division.identifier',
      padLeft: true
    },
    {
      id: 2,
      description: 'Tipo (B, OE, CA)',
      tooltip: 'Tipo (Borrador, Original Electrónico, Copia auténtica)',
      img: 'fa-th-list',
      field: 'type'
    },
    //        { id: 3, description: 'Identificador', img: 'fa-circle-o', field: 'identifier' },
    // { id: 4, description: 'Usuario', img: 'fa-user-o', field: ['user.person.lastName', 'user.person.name'] },
    {
      id: 5,
      description: 'Estado del documento',
      tooltip: 'Estado del documento',
      img: 'fa-folder',
      field: 'currentState.type.description'
    },
    {
      id: 6,
      description: 'Tipo de documento',
      tooltip: 'Tipo de documento',
      img: 'fa-bookmark-o',
      field: 'entity.documentClass.name'
    },
    {
      id: 7,
      description: 'Fase',
      tooltip: 'Fase',
      img: 'fa-folder',
      field: 'phase.description',
      sortField: 'phase.identifier',
      padLeft: true
    },
    {
      id: 8,
      description: 'Tercero',
      tooltip: 'Tercero',
      img: 'fa-building',
      field: 'thirdParty.name',
      sortField: 'thirdParty.name'
    }
  ];

  NO_INFORMATION_STR = '<Sin informacion>';

  private userService: UserService;
  private dossierService: DossierService;
  public documentService: DocumentService;
  private appConfig: AppConfiguration;
  canCreateProcedure = false;
  canOtherProcedures = false;
  canFinalizationTerminationProcedure = false;
  canNewDocument = false;
  canExport = false
  profileService: ProfileService;
  hasSelectedDocuments = false;



  // Modal de filtros
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  public filterModel: any;
  filtersVisible: boolean;
  aceptar: boolean;
  loaded = false;
  state: any;
  activeFilters: Array<any> = [];
  clientFiltersKeys = ['userStateId', 'stateId', 'stateFrom', 'stateTo', 'creationDateFrom', 'creationDateTo', 'userSignatureId', 'signatureFrom', 'signatureTo'];
  clientFilters: any = {};

  // Modal de columnas
  public selectColumnsVisible = false;
  public colsSelectorWindowHash: string;


  allColumns: any[] = [{
    'name': this.translate.instant('Documents.state'),
    'code': 'STATE'
  },
  {
    'name': this.translate.instant('Documents.creationDate'),
    'code': 'CREATIONDATE'
  },
  {
    'name': this.translate.instant('Documents.date'),
    'code': 'DATE'
  }, {
    'name': this.translate.instant('General.user'),
    'code': 'USER'
  },
  ];

  visibleColumns: any[] = [];

  defaultVisibleColumns: any[] = [
    {
      'name': this.translate.instant('Documents.state'),
      'code': 'STATE'
    },
    {
      'name': this.translate.instant('Documents.date'),
      'code': 'DATE'
    }

  ];

  _colsCodes: any[];





  // Menú de acciones de la tabla de documentos
  items = [
    {
      label: 'Expandir todo', icon: 'fas fa-plus', command: (event: Event) => {
        this.expandORcollapse(true);
      }
    },
    {
      label: 'Colapsar todo', icon: 'fas fa-minus', command: (event: Event) => {
        this.expandORcollapse(false);
      }
    },
    {
      label: 'Selector de columnas', icon: 'fas fa-columns',
      command: (event: Event) => {
        this.selectColumnsVisible = true
      }
    }
  ];
  orderColum = 'CREATIONDATE';
  tooltipMessage: string;
  searching = false;
  /**
   * Se permite seleccionar el circuito de subsanacion de un documento
   */
  private selectCorrectProcedure = false;


  constructor(
    @Optional() private elem: ElementRef,
    @Optional() private dialogRef: DynamicDialogRef,
    @Optional() private dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private router: Router,
    route: ActivatedRoute,
    private store: Store<AppState>,
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    public configuration: Configuration,
    public confirmationService: ConfirmationService,
    public propertyService: PropertyService,
    public translate: TranslateService,
    private datePipe: DatePipe,
    private plycaErrorHandler: PlycaErrorHandler,
    private userPrefsService: UserPrefsService
  ) {
    super();
    this.userService = ServiceLocator.injector.get(UserService);
    this.dossierService = ServiceLocator.injector.get(DossierService);
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    this.profileService = ServiceLocator.injector.get(ProfileService);
    this.docFilters = {};

    // Se estable la visualización del filtro mostrar comunicaciones  por propiedad de configuración de cliente.
    // Por defecto si no existe la propiedad, el valor es false
    // En producto el valor es true definido en conf.json
    this.ignoreNotificationsDefault = this.appConfig.getValue('documentSearch.filter.ignoreNotifications.default');
    if (this.ignoreNotificationsDefault === undefined) {
      this.ignoreNotificationsDefault = true;
    }
    this.filterWindowHash = generateRandomIdentifier();
    this.colsSelectorWindowHash = generateRandomIdentifier();
    if (dialogConfig) {
      this.windowHash = generateRandomIdentifier();
      this.documentId = dialogConfig['documentId'];
      if (this.documentId) {
        this.isRelatedDocsMode = true;
        this.isModalWindow = true;
      }
    }
    if (lodash.isEmpty(dialogConfig)) {
      this.windowHash = undefined;
    }
    if (dialogConfig && dialogConfig['id']) {
      this.dossierId = dialogConfig['id'];
      this.docFilters = dialogConfig['docFilters'];

      // this.selectionMode = dialogConfig['selectionMode'];
      this.selectedDocs = dialogConfig['selectedDocs'];
      this.selectedDocsReadOnly = dialogConfig['selectedDocsReadOnly'];
      this.SELECTION_MODE = dialogConfig['SELECTION_MODE'];
      if (this.SELECTION_MODE === undefined) {
        if (dialogConfig['selectionMode']) {
          this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_SINGLE_SELECTION;
        } else {
          this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_OFF;
        }
      }
      this.isModalWindow = true;
      this.showHeader = false;
    } else {
      this.subscribe(route.params, params => {
        this.dossierId = params['id'];
      });
    }


    // De momento agrupar por tercero no esta disponible
    // Requiere un recalculo cuando el tercero cambia por alguna incidencia
    this.groupsBy = this.groupsBy.filter(x => x.id !== 8);


    this.subscribe(this.userPrefsService.getUserPrefs(),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        this.initPrefs();
        // PARA EVITAR ERRORES POR TRATAR DE AGRUPAR POR CAMPOS QUE YA NO EXISTEN
        let limpiar = false;
        this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId).activeGroups.forEach(x => {
          let v = this.groupsBy[x];
          if (!v) {
            limpiar = true;
          }
        });

        if (limpiar) {
          this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId).activeGroups = [0, 4];
        }
        this.activeGroups = this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId).activeGroups;

        if (!this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters
          || JSON.stringify(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters) == '{}') {
          this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters = {
            includeCancelled: false,
            ignoreNotifications: this.ignoreNotificationsDefault,
            avoidTemporaryDocs: false
          };
        }
        this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters.dossierId = this.dossierId;

        this.updateActiveFilters();
      });
    this.canExport = this.profileService.exportsEnabled;
  }

  initPrefs() {

    // Se establece por defecto si no hay
    // Los valores de preferencias se definen por expediente

    // inicializar la variable por si no viene en las preferencias
    if (!this.userPrefs) {
      this.userPrefs = new UserPrefs();
    }
    if (!this.userPrefs.documentsViewPrefs) {
      this.userPrefs.documentsViewPrefs = new DocumentsViewPrefs();
    }
    if (!(this.userPrefs.documentsViewPrefs.prefs instanceof Map)) {
      this.userPrefs.documentsViewPrefs.prefs = new Map<string, DossierDocumentsPrefs>();
    }
    if (!this.userPrefs.documentsViewPrefs.prefs.has(this.dossierId)) {
      this.userPrefs.documentsViewPrefs.prefs.set(this.dossierId, new DossierDocumentsPrefs());
    }

    if (!this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._expandedNodes) {
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._expandedNodes = [];
    }

    if (!this.userPrefs.documentsViewPrefs.visibleColumns || this.userPrefs.documentsViewPrefs.visibleColumns.length == 0) {
      this.userPrefs.documentsViewPrefs.visibleColumns = this.defaultVisibleColumns;
      this.visibleColumns = this.defaultVisibleColumns;
      this._colsCodes = this.visibleColumns.map(element => element.code);
    } else {
      this.visibleColumns = this.userPrefs.documentsViewPrefs.visibleColumns;
      this._colsCodes = this.visibleColumns.map(element => element.code);
    }


  }

  ngOnInit(): void {
    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;
        this.load();
      });
    this.subscribe(this.propertyService.getProperty('GESTDOC_SELCIRCUITO_SUBSANAR'),
      (value: string) => {
        this.selectCorrectProcedure = value === '1';
      });
  }

  ngAfterViewInit(): void {
  }

  initHeader(): void {
    // CONSULTA DE PROPIEDADES para que estén disponibles en la vista
    // Se habilita el botón de Crear Modelo solo para los perfiles configurados
    /*this.subscribe(


      this.propertyService.getProperty('PERFILESCREARMODELO', '0;5').pipe(finalize(() => this.loadHeader())),


      (value: string) => {
        value = value.replace(new RegExp(/[;]/g), ',');
        if (!this.isModalWindow
          && this.userService.hasRoles(value)) {
          this.createModel = true;

        }


      }

    );*/





    this.subscribe(forkJoin([
      // Consultamos el expediente con el flag que nos indica si somos usuario en modo soporte
      this.propertyService.getProperty('PERFILESCREARMODELO', '0;5'),
      this.plycaService.getAvailableAction('ACTION_OTHER_PROCEDURE', this.dossierId, 'PROJECTENTITY'),
      this.plycaService.getAvailableAction('ACTION_FINALIZATION_TERMINATION_PROCEDURE', this.dossierId, 'PROJECTENTITY')]
    )
      .pipe(finalize(() => this.loadHeader())),
      result => {
        if (result[0]) {
          let value = result[0];
          value = value.replace(new RegExp(/[;]/g), ',');
          if (!this.isModalWindow
            && this.userService.hasRoles(value)) {
            this.createModel = true;
          }
        }
        if (result[1] && result[1].actions[0]) {
          this.canOtherProcedures = this.canOtherProcedures && result[1].actions[0].enabled;
        } else {
          this.canOtherProcedures = false;
        }

        if (result[2] && result[2].actions[0]) {
          this.canFinalizationTerminationProcedure = this.canFinalizationTerminationProcedure && result[2].actions[0].enabled;
        } else {
          this.canFinalizationTerminationProcedure = false;
        }
      });


  }


  loadHeader(): void {
    if (this.showHeader) {
      this.headerActionsService.setTaskDescription(
        this.elem,
        'Documents.title',
        'far fa-file-alt',
        function () {
          return this.isDocsLoaded();
        }.bind(this)
      );
      this.headerActionsService.setProject(this.elem, this.dossier, false);
    }

    this.loadActionsInit();

  }

  ngOnDestroy(): void {
    this.dialogRef = null;
    this.dialogService = null;
    this.dialogConfig = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.headerActionsService.clearWindowActions(this.filterWindowHash);
    if (!this.windowHash) {
      this.headerActionsService.clearActions();
    }


    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    super.ngOnDestroy();
  }

  load() {
    this.documentService.documentsLoaded = false;
    this.waitService.startWaiting();
    if (this.dossierId && !this.dossierLoaded) {
      console.log('Documentos del expediente: ' + this.dossierId);
      this.loadDossier();

    }
    this.loadDocuments();
    // this.loadDocumentsSettings(); // incluir para los filtros
  }

  loadDossier() {
    this.subscribe(this.plycaService.getDossier(this.dossierId).pipe(
      tap((param: any) => {
        this.dossier = param;
        if (this.showHeader) {
          this.headerActionsService.setProject(this.elem, this.dossier, false);
        }

        // canNewDocument = almacena la información acerca de si se habilita el botón de crear documento
        // dependerá de si el usuario tiene perfil y tipo de expediente (listadocnombre)  entre los configurados
        let profileNewDocument = this.appConfig.getValue('documents.newDocument.profiles');
        this.canNewDocument = this.dossier.userAllowedForSupport && (!profileNewDocument
          || this.userService.hasRoles(profileNewDocument, this.dossier.division.documentClass.application));

        let profileCreateProcedure = this.appConfig.getValue('documents.createProcedure.profiles');
        this.canCreateProcedure = this.dossier.userAllowedForSupport && (!profileCreateProcedure
          || this.userService.hasRoles(profileCreateProcedure, this.dossier.division.documentClass.application));

        let profileFinalizationProcedures = this.appConfig.getValue('documents.finalizationProcedures.profiles');
        this.canFinalizationTerminationProcedure = !profileFinalizationProcedures ||
          this.userService.hasRoles(profileFinalizationProcedures, this.dossier.division.documentClass.application);

        let profileOtherProcedures = this.appConfig.getValue('documents.otherProcedure.profiles');
        this.canOtherProcedures = !profileOtherProcedures ||
          this.userService.hasRoles(profileOtherProcedures, this.dossier.division.documentClass.application);

        this.initHeader()
        // console.log('Expediente consultado: ');
        // console.log(this.dossier);
      }),
      finalize(() => this.dossierLoaded = true))
    );
  }

  public isDossierLoaded(): boolean {
    return this.dossier;
  }

  // SE INVOCA AL PULSAR SOBRE ALGUNA DE LAS CABECERAS
  public reorder(column: string) {
    this.orderColum = column;
    if (this.isRelatedDocsMode) {
      this.subscribe(this.relatedDocuments(true));
    } else {
      this.subscribe(this.useDocuments());
    }
  }

  loadDocuments(): void {
    this.waitService.startWaiting();
    if (this.isRelatedDocsMode) {
      this.loadRelatedDocuments();
    } else if (!this.dossierId) {
      this.loadDocumentsWithoutDossier();
    } else {
      this.loadDocumentsByDossier();
    }
  }

  private loadRelatedDocuments(): void {
    let params: any;
    params = {};
    params.expand = 'expansionSet:RELATED_DOCS_WEBCLIENT';
    let documentObs = this.plycaService.get<DocumentDTO>(
      this.configuration.DOCUMENTS_SERVICE_URL, this.documentId,
      params
    );
    this.subscribe(
      documentObs
        .pipe(
          switchMap(
            (document: DocumentDTO) => {
              this.documents = [];
              this.filteredDocuments = [];
              this.relatedDoc = document;
              if (document.relatedDocuments) {
                this.documents = document.relatedDocuments;
              }
              return this.relatedDocuments()
                .pipe(
                  finalize(() => {
                    this.waitService.cancelWaiting();
                    this.documentService.documentsLoaded = true;
                    this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_DOCUMENTS));
                  })
                )
            }
          ),
          catchError((e) => {
            this.plycaErrorHandler.showServerError(e);
            this.waitService.cancelWaiting();
            return of([]);
          })
        ));
  }

  private loadDocumentsWithoutDossier(): void {
    this.subscribe(this.plycaService
      .getDocuments()
      .pipe(
        switchMap(
          (param: PaginationDTO<any>) => {
            if (param) {
              this.documents = param.content;

            } else {
              this.documents = [];
              this.filteredDocuments = [];
              this.groupedDocuments = [];

            }
            return this.useDocuments()
              .pipe(
                finalize(() => {
                  this.waitService.cancelWaiting();
                  this.documentService.documentsLoaded = true;
                  this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_DOCUMENTS));
                })
              )
          }
        )
        ,
        catchError((e) => {
          this.plycaErrorHandler.showServerError(e);
          this.waitService.cancelWaiting();
          return of([]);
        }))
    );
  }

  private loadDocumentsByDossier(): void {
    // ACTUALIZAR FILTROS EN PREFERENCIAS DE USUARIO
    try {
      //  Object.assign(this._filters, this._filters);
      let thisUserPrefs = this.userPrefs;
      this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
      this.updateActiveFilters();
    } catch { }

    this.subscribe(this.plycaService
      .query<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, this.getHttpParams())
      .pipe(
        switchMap(
          (param: PaginationDTO<any>) => {
            if (param) {
              this.documents = param.content;
            } else {
              this.documents = [];
              this.filteredDocuments = [];
              this.groupedDocuments = [];
            }
            return this.useDocuments()
              .pipe(
                finalize(() => {
                  this.waitService.cancelWaiting();
                  this.documentService.documentsLoaded = true;
                  this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_DOCUMENTS));
                })
              )

          }
        )
        ,
        catchError((e) => {
          this.plycaErrorHandler.showServerError(e);
          this.waitService.cancelWaiting();
          return of([]);
        }))
    );
  }

  private useDocuments(): Observable<any> {
    if (this.documents.length > 0) {
      // TODO ¿? se ordena dos veces
      this.documents = this.documents.sort(this.documentColumnComparator.bind(this));
      this.filteredDocuments = this.applyClientFilters(this.documents);
      this.groupDocuments();
    }
    return of(true);
  }

  private relatedDocuments(reorder = false): Observable<any> {
    // Se establece solo una agrupación
    this.groupsBy = [
      {
        id: 1,
        description: 'Relación',
        img: 'fa-exchange-alt',
        field: 'relation.description',
        sortField: 'relation.description'
      }
    ];
    this.activeGroups = [0];

    // Se mapea la lista de documentos y 'relation' para agrupar por ella

    if (this.documents.length > 0) {
      let docs;
      if (!reorder) {    // Solo cargar la pantalla, al ordenar ya están mapeados los documentos
        docs = this.documents.map(
          (doc) => {
            let newDoc = doc.document;
            newDoc['relation'] = {};
            newDoc['relation'] = doc.relation;
            return newDoc;
          }
        );
        this.documents = docs;

      }

      this.filteredDocuments = this.documents;

      if (this.filteredDocuments && this.filteredDocuments.length > 0) {
        this.groupDocuments(); // Ordena dentro
      }
      // Se muestran expandidos por defecto
      this.expandORcollapse(true);
    }
    return of(true);
  }

  private documentColumnComparator(doc1: any, doc2: any): number {
    let date1 = undefined;
    let date2 = undefined;

    switch (this.orderColum) {
      case 'VERSION': {
        date1 = doc1.currentVersion && doc1.currentVersion.versionNumber ? doc1.currentVersion.versionNumber : undefined;
        date2 = doc2.currentVersion && doc2.currentVersion.versionNumber ? doc2.currentVersion.versionNumber : undefined;
        break;
      }
      case 'DATE': {
        date1 = doc1.currentState && doc1.currentState.order ? doc1.currentState.order : undefined;
        date2 = doc2.currentState && doc2.currentState.order ? doc2.currentState.order : undefined;
        break;
      }
      case 'CREATIONDATE': {
        date1 = doc1.creationDate ? doc1.creationDate : undefined;
        date2 = doc2.creationDate ? doc2.creationDate : undefined;
        break;
      }
      case 'STATE': {
        date1 = doc1.currentState && doc1.currentState.type && doc1.currentState.type.description
          ? doc1.currentState.type.description : undefined;
        date2 = doc2.currentState && doc2.currentState.type && doc2.currentState.type.description
          ? doc2.currentState.type.description : undefined;
        break;
      }
      case 'USER': {
        date1 = doc1.user && doc1.user.person && doc1.user.person.name ? doc1.user.person.name : undefined;
        date2 = doc2.user && doc2.user.person && doc2.user.person.name ? doc2.user.person.name : undefined;
        break;
      }
      default: {
        date1 = doc1.date ? doc1.date : undefined;
        date2 = doc2.date ? doc2.date : undefined;
        break;
      }
    }

    if (!date1 && !date2) {
      // son iguales
      return 0;
    } else if (!date1) {
      // doc1 va despues de doc2
      return -1;
    } else if (!date2) {
      // doc1 va antes que doc2
      return 1;
    } if (date1 < date2) {
      return -1;
    } else if (date1 > date2) {
      return 1;
    } else {
      return 0;
    }
    /*
    let time1 = date1 instanceof Date ? date1.getTime() : date1;
    let time2 = date2 instanceof Date ? date2.getTime() : date2;
    return time1 - time2;*/
  }

  groupedDocumentsLoaded(): boolean {
    return this.groupedDocuments && this.groupedDocuments.length > 0;
  }

  getAgrupaciones(): Array<any> {
    return this.groupsBy.filter(item => {
      // return this.activeGroups.indexOf(this.groupsBy.indexOf(item)) === -1;
      return this.activeGroups.indexOf(this.groupsBy.indexOf(item)) === -1;
    });
  }

  clearGroup(index: number) {
    this.activeGroups.splice(index, 1);
    this.groupDocuments();
  }

  setAgrupacion(index: number, grp: any) {
    this.activeGroups[index] = this.groupsBy.indexOf(grp);
    while (this.activeGroups.length > index + 1) {
      this.activeGroups.pop();
    }
    this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId).activeGroups = this.activeGroups;
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    this.groupDocuments();
  }

  private groupDocuments(): any {
    // this.filteredDocuments = this.filteredDocuments.sort((doc1, doc2): number => {
    //   let date1 = undefined;
    //   let date2 = undefined;
    //   switch (this.orderColum) {
    //     case 'DATE': {
    //       date1 = doc1.currentState && doc1.currentState.order ? doc1.currentState.order : undefined;
    //       date2 = doc2.currentState && doc2.currentState.order ? doc2.currentState.order : undefined;
    //       break;
    //     }
    //     case 'CREATIONDATE': {
    //       date1 = doc1.creationDate ? doc1.creationDate : undefined;
    //       date2 = doc2.creationDate ? doc2.creationDate : undefined;
    //       break;
    //     }
    //     case 'STATE': {
    //       date1 = doc1.currentState && doc1.currentState.type && doc1.currentState.type.description
    //         ? doc1.currentState.type.description : undefined;
    //       date2 = doc2.currentState && doc2.currentState.type && doc2.currentState.type.description
    //         ? doc2.currentState.type.description : undefined;
    //       break;
    //     }
    //     case 'USER': {
    //       date1 = doc1.user && doc1.user.name ? doc1.user.name : undefined;
    //       date2 = doc2.user && doc2.user.name ? doc2.user.name : undefined;
    //       break;
    //     }
    //     default: {
    //       date1 = doc1.date ? doc1.date : undefined;
    //       date2 = doc2.date ? doc2.date : undefined;
    //       break;
    //     }
    //   }

    //   if (!date1 && !date2) {
    //     // son iguales
    //     return 0;
    //   } else if (!date1) {
    //     // doc1 va despues de doc2
    //     return -1;
    //   } else if (!date2) {
    //     // doc1 va antes que doc2
    //     return 1;
    //   } else if (date1 < date2) {
    //     return -1;
    //   } else if (date1 > date2) {
    //     return 1;
    //   } else {
    //     return 0;
    //   }
    //   /*
    //   let time1 = date1 instanceof Date ? date1.getTime() : date1;
    //   let time2 = date2 instanceof Date ? date2.getTime() : date2;
    //   return time1 - time2;
    //    */
    // });
    this.filteredDocuments =
      this.filteredDocuments.sort(this.documentColumnComparator.bind(this));

    let nodeList: Array<any> = [];
    // limpiar nodos seleccionados
    this.selectedNodes = [];

    if (this.activeGroups.length > 0 && this.groupsBy[0]) {
      nodeList = this.internalGroupDocuments(
        this.filteredDocuments,
        this.groupsBy[this.activeGroups[0]], ''
      );
      this.recursiveGroupDocuments(1, nodeList);
    } else {
      this.filteredDocuments.forEach((x: DocumentDTO) => {
        nodeList.push(this.document2Node(x));
      });
    }
    this.groupedDocuments = nodeList;
  }

  // Para controlar si se pueden agregar más agrupaciones. Menos de 3 y que no esté ya incluida la agrupacion por divisiones
  canAddGroup(): boolean {
    this.tooltipMessage = 'Pulse para seleccionar agrupación.';
    let containsDivisionGroup = false;
    this.activeGroups.forEach(grp => {
      containsDivisionGroup = containsDivisionGroup || this.groupsBy[grp]['field'] === 'entity.division.name'
    });
    if (containsDivisionGroup) {
      this.tooltipMessage = this.translate.instant('Documents.message.grouping.division');
    } else if (!(this.activeGroups.length < 3)) {
      this.tooltipMessage = this.translate.instant('Documents.message.grouping.max');
    }
    return this.activeGroups.length < 3 && !containsDivisionGroup;
  }

  private recursiveGroupDocuments(
    activeGroupIndex: number,
    nodeArray: Array<any>
  ) {
    // EVITAR AGRUPACIONES POR DEBAJO DE LAS DIVIONES
    let groupByParent = this.groupsBy[this.activeGroups[activeGroupIndex - 1]];
    if (groupByParent && groupByParent['field'] === 'entity.division.name') {
      return nodeArray;
    }

    if (
      activeGroupIndex < this.activeGroups.length &&
      this.groupsBy[activeGroupIndex]
    ) {
      nodeArray.forEach((item: any) => {
        // console.log('agrupando por item', item);
        let nodeListTmp: Array<DocumentDTO> = [];
        if (item.children) {
          item.children.forEach((x: any) => {
            if (x.data.document) {
              nodeListTmp.push(x.data.document);
            }
          });
        }
        let tmp: Array<any> = this.internalGroupDocuments(
          nodeListTmp,
          this.groupsBy[this.activeGroups[activeGroupIndex]], item.NODEID);
        item.children = tmp;
        this.recursiveGroupDocuments(activeGroupIndex + 1, tmp);
      });
    }
  }

  nodeSelect(event) {
    console.log('Node Selected', event.node);
  }

  private document2Node(doc: DocumentDTO): any {
    let node = {
      data: {
        name: doc.name,
        identifier: doc.identifier,
        document: doc,
        creationDate: doc.creationDate,
        date: doc.date,
      }
    };
    if (this.selectedDocs) {
      if (this.selectedDocs.find(_doc => _doc.identifier == doc.identifier) != undefined) {
        this.selectedNodes.push(node);
      }
    }
    return node;
  }

  private internalGroupDocuments(
    documentList: Array<DocumentDTO>,
    groupBy: any, parentNODEID: string
  ): any {
    let nodeList = [];
    documentList.forEach((x: DocumentDTO) => {
      let groupId = this.getGroupBy(x, groupBy);

      // TRATAMIENTO DOCUMENTOS SIN GRUPO
      if (groupId === undefined) {
        groupId = this.NO_INFORMATION_STR;
        if (groupBy.field === 'thirdParty.name') {
          groupId = this.dossier.expedienteId;
        }
      }

      let groupDesc = groupId;
      if (groupBy.field === 'thirdParty.name') {
        let taxIdentifier = x.thirdParty?.taxIdentifier ? x.thirdParty.taxIdentifier + ' - ' : '';
        groupDesc = taxIdentifier + groupDesc;
      }
      if (groupBy.sortField) {
        groupId = objectPath.get(x, groupBy.sortField);
      }

      let nodeGroup;
      // Recuperar el grupo (si no existe se crea)
      if (this.getGroupIndex(nodeList, groupId) === -1) {
        let _parentGroup;
        if (groupBy.field === 'entity.division.name') {
          // si la agrupacion es por division, incluyo en el nodo parentGroup
          // (que es el id de la division padre) para luego crear la jerarquia de divisiones.
          _parentGroup = x.entity.division.parent?.identifier;

          // COMPROBAR SI EXISTE EL PADRE Y SI NO CREARLO (POR SI HAY DIVISIONES INTERMEDIAS SIN DOCUMENTOS).
          // ESTO PUEDE PASAR SI AGRUPO POR EJEMPLO POR FASE Y LUEGO POR DIVISION
          // Y EN FASE DE EJECUCIÓN TODOS LOS DOCUMENTOS SON DE UN PAGO O UNA INCIDENCIA(CASO RARO ?)
          let parentGroupId = x.entity.division.parent?.identifier;
          if (parentGroupId && !parentGroupId.startsWith('0<>')) {
            let parentDesc = x.entity.division.parent?.name;
            // HACK FEO: SI NO TENGO EL NAME DEL PADRE, LO CALCULO DE LA DESCRIPCION DE LA JERARQUIA
            if (!parentDesc) {
              try {
                parentDesc = x.entity.division.hierarchicalDescription.substring(0, x.entity.division.hierarchicalDescription.indexOf('/'));
              } catch {
                parentDesc = parentGroupId;
              }
            }
            if (this.getGroupIndex(nodeList, parentGroupId) === -1) {
              let _group = this.changeDivisionGroupIcon(x.entity.division.parent, groupBy);
              nodeGroup = {
                data: {
                  name: parentDesc,
                  identifier: parentGroupId,
                  group: _group,
                },
                expanded: (this.userPrefs.documentsViewPrefs.prefs
                  .get(this.dossierId)._expandedNodes.includes(parentNODEID + groupBy.field + parentGroupId)),
                NODEID: parentNODEID + groupBy.field + parentGroupId,
                children: []
              };
              nodeList.push(nodeGroup);
            }
          }
        }

        // crearNodo de la agrupacion
        let _group = this.changeDivisionGroupIcon(x.entity.division, groupBy);
        nodeGroup = {
          data: {
            name: groupDesc,
            identifier: groupId,
            group: _group,
            _parentGroup: _parentGroup
          },
          expanded: (this.userPrefs.documentsViewPrefs.prefs
            .get(this.dossierId)._expandedNodes.includes(parentNODEID + groupBy.field + groupId)),
          NODEID: parentNODEID + groupBy.field + groupId,
          children: []
        };
        nodeList.push(nodeGroup);
      } else {
        nodeGroup = nodeList[this.getGroupIndex(nodeList, groupId)];
      }
      nodeGroup.children.push(this.document2Node(x));
    });
    // Ordenar nodos
    nodeList = nodeList.sort((left, right): number => {
      if (
        !left.children &&
        left.data.date &&
        !right.children &&
        right.data.date
      ) {
        // Si no es un grupo lo ordenamos por fecha
        return left.data.date - right.data.date;
      }

      let leftId: string = getSimpleIdentifierFromString(left.data.identifier);
      let rightId: string = getSimpleIdentifierFromString(right.data.identifier);

      // Como los identifier son string, la ordenacion es lexicografica.
      // Si el grupo tiene la marca de padLeft (como la fase), asi que se concatenan 0 por la izda para que la ordenacion sea correcta
      // y por ejemplo un elemento con identificador 1 vaya por delante de 10.
      if (groupBy.padLeft) {
        leftId = this.padLeft('' + leftId, '0', 5);
        rightId = this.padLeft('' + rightId, '0', 5);
      }

      if (leftId) {
        leftId = leftId.toLowerCase();
      }
      if (rightId) {
        rightId = rightId.toLowerCase();
      }
      let ret;
      if ((!left.children && left.data.date) || leftId < rightId) {
        ret = -1;
      } else if ((!right.children && right.data.date) || leftId > rightId) {
        ret = 1;
      } else {
        ret = 0;
      }
      return ret;
    });

    // Generar la jerarquia de divisiones
    if (groupBy.field === 'entity.division.name') {
      let newNodeList = [];
      nodeList.forEach(node => {
        // Si es la division 0, los documentos se añaden directamente
        if (node.data.identifier.startsWith('0<>')) {
          newNodeList.push(...node.children);
        } else {
          // si el padre es la division 0 se añade directamente el nodo o no hay padre
          // (solo puede no haber padre si es una division padre que no tiene documentos y se ha generado el nodo)
          if (!node.data._parentGroup || node.data._parentGroup.startsWith('0<>')) {
            newNodeList.push(node);
          } else {
            // si el padre NO es la division 0, se busca el nodo de la division padre y se añade como hijo de esta
            let parentNodeGroup = nodeList[this.getGroupIndex(nodeList, node.data._parentGroup)];
            if (!parentNodeGroup) {
              newNodeList.push(node);
            } else {
              parentNodeGroup.children.push(node);
            }
          }
        }
      });
      return newNodeList;
    }
    return nodeList;
  }

  changeDivisionGroupIcon(division: DivisionDTO, groupBy) {
    // PRUEBA PARA CAMBIAR ICONO POR TIPO DE DIVISION:
    // POR AHORA SOLAMENTE CAMBIO CARPETA DE PAGOS AMARILLO
    if (groupBy.field === 'entity.division.name') {
      let newIcon;
      if (division?.documentClass?.abbreviation === 'EXPADJ') {
        // newIcon = 'fa-folder text-info';
      } else if (division?.documentClass?.abbreviation === 'EXPINC') {
        // newIcon = 'fa-folder text-info';
      } else if (division?.documentClass?.abbreviation === 'EXPADJEJEC') {
        newIcon = 'fa-folder text-warning';
      }
      // si ha cambiado el icono
      if (newIcon) {
        let _group = lodash.cloneDeep(groupBy);
        _group.img = newIcon;
        return _group;
      }
    }
    return groupBy;
  }


  private padLeft(text: string, padChar: string, size: number): string {
    while (text.length < size) {
      text = padChar + text;
    }
    return text;
  }

  getGroupBy(x: DocumentDTO, groupBy: any): any {
    let ret: any = '';
    if (groupBy.field instanceof Array) {
      groupBy.field.forEach(f => {
        ret = ret + ' ' + objectPath.get(x, f);
      });
    } else {
      ret = objectPath.get(x, groupBy.field);
    }
    return ret;
  }

  getGroupIndex(nodeList: Array<any>, id: any): number {
    let ret = -1;
    nodeList.forEach((item, index) => {
      if (item.data.identifier === id) {
        ret = index;
      }
    });
    return ret;
  }

  public selectDocument(document: DocumentDTO): void {
    this.dialogRef.close(document);
  }

  documentsVisibles(): boolean {
    return this.filteredDocuments && this.filteredDocuments.length > 0;
  }

  public isDocsLoaded(): boolean {
    return this.documentService.documentsLoaded;
  }

  /* FILTROS */
  public updateFilter(event: Event) {
    let val: string = this.filterText;
    if (this.filterText === '' || // En el caso inicial o cuando se borrar todos los caracteres
      this.filterText &&
      this.filterText.length >= this.MIN_SEARCH_TEXT_LENGHT
    ) {
      this.searching = true;


      this.filteredDocuments = this.documents.filter(function (d: any) {
        let docClassName = '';
        if (d.documentClass && d.documentClass.name) {
          docClassName = d.documentClass.name;
        }

        let docName = '';
        if (d.name) {
          docName = d.name;
        }

        let idExpte = '';
        if (d.dossier && d.dossier.expedienteId) {
          idExpte = d.dossier.expedienteId;
        }

        return (
          docClassName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
          !val ||
          docName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
          !val ||
          idExpte.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
          !val
        );
      });

      this.groupDocuments();



      setTimeout(() => {
        this.searching = false;
      }, 300);




    }
  }

  public clear() {
    Object.keys(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters)
      .forEach(key => delete this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[key]);

    this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters.includeCancelled = false;
    this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters.ignoreNotifications = this.ignoreNotificationsDefault;
    this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters.dossierId = this.dossierId;

    this.updateActiveFilters();

    this.filteredDocuments = this.documents;
    this.groupDocuments();
    this.filtersVisible = false;
  }

  public showFilters(): boolean {
    let show = true;

    show = this.activeFilters?.length > 1
      ||
      (
        this.activeFilters?.length === 1
        &&
        (this.activeFilters[0].key && this.activeFilters[0].key !== 'dossierId')
      );
    /*
        let defaultFilters = {
          includeCancelled: false,
          ignoreNotifications: this.ignoreNotificationsDefault
        };
        defaultFilters['dossierId'] = this.dossierId;
        let defaultFilters1 = {
          includeCancelled: false,
          ignoreNotifications: undefined
        };
        defaultFilters1['dossierId'] = this.dossierId;

        show = (JSON.stringify(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters) != JSON.stringify(defaultFilters))
          && (JSON.stringify(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters) != JSON.stringify(defaultFilters1));
    */
    return show;
  }



  // Invocacion al componente que permite generar un fichero a partir de una plantilla con los datos del expediente
  generateTemplate() {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('TemplateGeneration.generateAction'),
      width: '70%',
      style: { overflow: 'hidden' }
    };
    config['dossier'] = this.dossier;
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));
    const ref = this.dialogService.open(newTemplateComponent, config);
    this.subscribe(ref.onClose,
      () => {
        this.subscribe(this.helpService.showContextHelpObservable(curentHelpTags));
      });
  }

  newDocument() {
    this.router.navigate(['basicDocument'], {
      queryParams: { dossierId: this.dossierId, forceRelease: 'true' }
    });
  }

  // Invocarcion al componente para iniciar el circuito de tramitacion de un nuevo documento
  private createProcedure(doc?: DocumentDTO): void {
    let ref: DynamicDialogRef;
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Documents.actions.newProcedure'),
      width: '80%',
      style: { overflow: 'hidden' }
    };
    if (getSimpleIdentifierFromString(this.dossier?.modoTramitacion?.identifier) === MANUALPROCESSINGMODE_ID) {
      config.data = {
        dossierId: this.dossier.identifier,
        document: doc
      };
      ref = this.dialogService.open(ProcedureCircuitComponent, config);
    } else {
      config['dossier'] = this.dossier;
      config['document'] = doc;
      ref = this.dialogService.open(procedureComponent, config);
    }
    this.subscribe(ref.onClose, () => this.load());
  }

  openDocument(doc: DocumentDTO) {
    let config: DynamicDialogConfig = {
      header: doc.name,
      width: '97%',
      styleClass: 'searchStyle'
    };

    config.data = {
      'id': doc.identifier

    }
    if (this.isRelatedDocsMode) {
      config.data['version'] = doc.currentVersion.versionNumber;
    }
    this.waitService.startWaiting();
    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose);
  }

  // TODO borrar??? es código antiguo, ahora es un action
  public rename(doc: DocumentDTO) {
    let context = new LongTextDTOModal('', '', false);
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Documents.actions.rename'),
      width: '50%',
      style: { overflow: 'hidden', 'max-height': '60%' },

      styleClass: 'formEdition'
    };

    context.label = '';
    context.text = 'ESTABLECER nombre actual del documento'
    config['context'] = context;

    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      if (result) {
        console.log(result);
      }
    });
  }

  public getDocMenuItem(dto: DocumentDTO): MenuItem[] {
    let items: MenuItem[] = [];

    let mn: MenuItem = {};

    mn = <MenuItem>{};
    mn.label = this.translate.instant('General.visualize');
    mn.title = this.translate.instant('General.visualize');
    mn.icon = 'fas fa-eye'
    mn.command = (event: Event) => {
      this.documentViewer(dto.identifier, this.router);
    };
    items.push(mn);

    if (this.appConfig.getValue('documents.tenderAccess.enabled') && dto.entity?.documentClass?.abbreviation === 'OF') {
      let menuDocOferta: MenuItem = {};

      menuDocOferta = <MenuItem>{};
      menuDocOferta.label = this.translate.instant('Documents.actions.tender');
      menuDocOferta.title = this.translate.instant('Documents.actions.tender');
      menuDocOferta.icon = 'far fa-file-alt'
      menuDocOferta.command = (event: Event) => {
        this.openTender(dto);
      };
      items.push(menuDocOferta);
    }

    return items;
  }

  // para que funcione:
  // 1. comp es el componente modal a abrir.
  // 2. comp debe estar en los entrycomponents del modulo del componente que invoque
  openTender(tenderDoc: DocumentDTO) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('Documents.actions.tender'),
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['dossier'] = this.dossier;
    // config['tenderId'] = tenderDoc.identifier;
    config['document'] = tenderDoc;
    const ref = this.dialogService.open(tenderViewComponent, config);
  }

  public getRelatedDocsMenuItem(dto: DocumentDTO): MenuItem[] {
    let items: MenuItem[] = [];

    let mn: MenuItem = {};

    mn = <MenuItem>{};
    mn.label = this.translate.instant('General.visualize');
    mn.title = this.translate.instant('General.visualize');
    mn.icon = 'fas fa-eye'
    mn.command = (event: Event) => {
      // this.documentViewer(dto.identifier, this.router);
      this.openDocument(dto);
    };

    items.push(mn);
    return items;
  }

  documentViewer(id: any, route: any) {
    route.navigate(['/documentViewer', id]);
  }

  export() {
    let exportProcess = this.createExportProcess();
    if (!this.hasSelectedDocuments) {
      this.uiService.showMessage(this.translate.instant('Documents.export.info'));
    } else {
      let config: DynamicDialogConfig = {
        header: this.translate.instant('Documents.export.process.title'),
        width: '70%',
        style: { overflow: 'scroll' },
        styleClass: 'formEdition'
      };

      if (exportProcess) {
        // config['id'] = exportProcess.identifier;
        config['exportProcess'] = exportProcess;
      }
      this.waitService.startWaiting();
      const ref = this.dialogService.open(
        exportProcessEditionPanelComponent,
        config
      );
      this.subscribe(ref.onClose, () => {
        this.SELECTION_MODE = undefined;
        this.loadActionsInit();
        this.load()
      })

    }
  }

  isExportMode(mode?: string) {
    // console.log('isExportMode (' + mode + '): ', this.EXPORT_MODE)
    // return this.EXPORT_MODE;
    return this.SELECTION_MODE === DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION;
  }

  isSingleSelection() {
    return this.SELECTION_MODE === DOCUMENT_SELECTION_MODE.SELECTION_MODE_SINGLE_SELECTION;
  }

  createExportProcess(): ExportProcessDTO {
    let exportProcess = new ExportProcessDTO();
    exportProcess.name = this.dossier.expedienteId ? this.dossier.expedienteId
      : this.dossier.identifier;
    exportProcess.description = exportProcess.name + ' ' + formatDate(new Date(), 'dd/MM/yyyy HH:mm', 'es-ES');
    // borrar y que se establezca al grabar!!
    exportProcess.ownerUser = this.userService.getUser();
    let exportResources = new ExportProcessResources();
    exportResources.exportProjectEntities = [];

    let exportProjectEntity = new ExportProjectEntityDTO();
    exportProjectEntity.projectEntity = this.dossier;
    exportProjectEntity.exportDocuments = this.getSelectedDocuments();
    this.hasSelectedDocuments = exportProjectEntity.exportDocuments && exportProjectEntity.exportDocuments.length > 0;
    exportResources.exportProjectEntities.push(exportProjectEntity);

    exportProcess.exportResources = exportResources;
    return exportProcess;
  }

  OLDgetSelectedDocuments(): Array<ExportDocumentDTO> {
    let selectedNodes: Array<any> = [];
    this.groupedDocuments.forEach((node: any) => {
      this.iteraNodes(selectedNodes, node);
    });

    let selectedDocs = [];
    selectedNodes.forEach(doc => {
      let exportdoc = new ExportDocumentDTO();
      exportdoc.document = doc;
      selectedDocs.push(exportdoc);
    });
    console.log('DOCUMENTOS A EXPORTAR:', selectedDocs)
    return selectedDocs;
  }

  getSelectedDocuments(): Array<ExportDocumentDTO> {
    // De los nodos seleccionados en árbol
    // Se eliminan los nodos que no son documentos
    let docNodes: Array<any> = [];
    this.selectedNodes.forEach((node: any) => {
      this.iteraNodes(docNodes, node);
    });


    let selectedList = [];
    docNodes.forEach(doc => {
      let exportdoc = new ExportDocumentDTO();
      exportdoc.document = doc;
      selectedList.push(exportdoc);
    });
    console.log('DOCUMENTOS A EXPORTAR:', selectedList)
    return selectedList;
  }

  iteraNodes(selectedNodes: Array<any>, node: any) {
    if (node.children) {
      /* node.children.forEach((child: TreeNode<any>) => {
         this.iteraNodes(selectedNodes, child);
       });*/
    } else {
      if (node['partialSelected'] !== undefined) {// TODO revisar este if es siempre true
        selectedNodes.push(node.data.document);
      }
    }
    return selectedNodes;
  }


  actionOtherProcedure() {
    this.subscribe(this.plycaService.getAction('ACTION_OTHER_PROCEDURE'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = this.dossier;
          config['runAction'] = true;
          config['paramsDef'] = actionDefinition.parametersDefinition;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
        }
      }
    });
  }

  actionFinalizationTerminationProcedure() {
    this.subscribe(this.plycaService.getAction('ACTION_FINALIZATION_TERMINATION_PROCEDURE'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = this.dossier;
          config['runAction'] = true;
          config['paramsDef'] = actionDefinition.parametersDefinition;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
        }
      }
    });
  }

  loadActionsInit() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.windowHash) {
      this.headerActionsService.clearActions();
    }
    let createProcedures = this.appConfig.getValue('procedures.buttons.createProcedures.visible');
    if (!this.isModalWindow) {

      if (this.canOtherProcedures && !createProcedures) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.otherProcedures',
            'fas fa-1-25x fa-plus',
            'btn-secondary',
            true)
          ,
          () => {
            this.actionOtherProcedure();
          });
      }

      if (this.canFinalizationTerminationProcedure && !createProcedures) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.finalizationTermination',
            'fas fa-1-25x fa-plus',
            'btn-secondary',
            true)
          ,
          () => {
            this.actionFinalizationTerminationProcedure();
          });
      }

      if (this.createModel) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.newModel',
            'fas fa-1-25x fa-plus',
            'btn-secondary',
            true)

          ,
          () => {
            this.generateTemplate();
          });
      }

      if (this.canNewDocument) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.newDocument',
            'fas fa-1-25x fa-plus',
            'btn-secondary', true
          ),
          () => {
            this.newDocument();
          });
      }
      if (this.canCreateProcedure && !createProcedures) {
        this.subscribe(this.headerActionsService
          .addAction(
            'Documents.actions.newProcedure',
            'fa-1-25x fas fa-plus',
            'btn-secondary',
            true
          ),
          () => {
            this.createProcedure();
          });
      }

      if (this.canExport) {
        this.subscribe(this.headerActionsService
          .addAction(
            'General.export.text',
            'fa-1-25x fa fa-file-export',
            'btn-secondary',
            true
          ),
          () => {
            if (this.SELECTION_MODE === DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION) {
              this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_OFF;
            } else {
              this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION;
            }
            this.loadActionsExport();

          });



      }

      this.subscribe(this.headerActionsService
        .addAction('Actualizar', 'fas fa-sync-alt', 'btn-primary', true),
        () => {
          this.load();
        });
      this.subscribe(this.headerActionsService
        .addAction(
          'General.filters',
          'fas fa-filter',
          'btn-primary',
          true
        ),
        () => {

          this.filtersVisible = true;
        });
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          !this.isExportMode('back')
        ),
        () => {
          this.uiService.routeBack();
        });
    } else {
      this.subscribe(this.headerActionsService
        .addWindowAction(
          'General.close',
          'fas fa-times',
          'btn-outline-secondary',
          true,
          this.windowHash
        ),
        () => {
          this.dialogRef.close();
        });
    }

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.search.text',
        'fas fa-lg fa-search',
        'btn-primary',
        true,
        this.filterWindowHash
      ),
      () => {
        this.aceptar = true;
        this.filtersVisible = false;
      });
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.clean',
        'fas fa-lg fa-undo',
        'btn-secondary',
        true,
        this.filterWindowHash
      ),
      () => {
        this.clear();
      });

  }

  loadActionsExport() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.windowHash) {
      this.headerActionsService.clearActions();
    }
    this.subscribe(this.headerActionsService
      .addAction(
        'Actions.execute', 'fas fa-share',
        'btn-primary',
        // this.isExportMode('export2')
        true
      ),
      () => {
        this.export();
      });

    this.subscribe(this.headerActionsService
      .addAction(
        'General.cancel',
        'fa-1-25x fa fa-times',
        'btn-secondary',
        true
      ),
      () => {
        if (this.SELECTION_MODE === DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION) {
          this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_OFF;
        } else {
          this.SELECTION_MODE = DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION;
        }
        this.loadActionsInit();

      });

  }

  expandORcollapse(value: boolean) {
    this.groupedDocuments.forEach(
      (node) => {
        node.expanded = value;
        if (node.children) {
          this.expandORcollapseNode(node.children, value);
        }
      }
    );
    this.groupedDocuments = [...this.groupedDocuments];
  }

  expandORcollapseNode(rootnode: any, value: boolean) {
    rootnode.forEach(
      (subnode) => {
        subnode.expanded = value;
        if (subnode.children) {
          this.expandORcollapseNode(subnode.children, value);
        }
      }
    );
  }

  public onCloseFilters() {
    if (this.aceptar) {
      this.loadDocuments();
    }
    this.filtersVisible = false;
  }

  // Modal de filtros
  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'dossierDocsSearchFiltersISettings.json',
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters
    ));
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  getHttpParams(): any { // { [param: string]: string | string[]; } {
    let _numFilters = 0;
    this.clientFilters = {};
    let serverFilters = {};
    let params = new HttpParams();

    // Si al abrir los documentos en modal
    // LLega algún filtro
    // Se suma al existente
    if (this.windowHash) {
      if (Object.keys(this.docFilters).length > 0) {
        lodash.merge(serverFilters, this.docFilters);
      }
      serverFilters['dossierId'] = this.dossierId;

      console.log(serverFilters);
      console.log(this.clientFilters);
      /*
            Object.keys(serverFilters)
              .forEach(function (key) {
                params = params.append(key, JSON.stringify(serverFilters[key]));
              });
      */

      params = Object.getOwnPropertyNames(serverFilters)
        .reduce((p, key) => {

          let value = serverFilters[key];
          if (value != undefined && value !== '') {
            _numFilters++;
            if (Array.isArray(value)) {
              return p.set(key, value.reduce(function (a, b) { return (a.identifier + ',' + b.identifier) }));
            } else if (value.identifier) {
              // si no es master data, la llamada a getSimpleIdentifierFromString no tiene efecto
              return p.set(key, getSimpleIdentifierFromString(value.identifier));
            } else if (value instanceof Date) {
              return p.set(key, '' + this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss'));
            } else {
              return p.set(key, value);

            }
          } else {
            return p;
          }



        }, new HttpParams()
        );
      this.activeFilters = [];
    } else {

      serverFilters = lodash.cloneDeep(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters);
      this.clientFiltersKeys.forEach(key => delete serverFilters[key]);
      this.clientFiltersKeys.forEach(key => this.clientFilters[key] =
        this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[key]);

      console.log(serverFilters);
      console.log(this.clientFilters);
      // Se comprueba los filtros tipo check, desmarcados tienen valor undefined
      // undefined = false
      let checkFilters = {
        avoidTemporaryDocs: false,
        includeCancelled: false,
        ignoreNotifications: false
      }
      serverFilters = lodash.merge(serverFilters, checkFilters);

      console.log(checkFilters);
      console.log(serverFilters);
      params = Object.getOwnPropertyNames(serverFilters)
        .reduce((p, key) => {

          let value = this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[key];



          if (value != undefined && value !== '') {
            _numFilters++;
            if (Array.isArray(value)) {
              return p.set(key, value.reduce(function (a, b) { return (a.identifier + ',' + b.identifier) }));
            } else if (value.identifier) {
              // si no es master data, la llamada a getSimpleIdentifierFromString no tiene efecto
              return p.set(key, getSimpleIdentifierFromString(value.identifier));
            } else if (value instanceof Date) {
              return p.set(key, '' + this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss'));
            } else {
              return p.set(key, this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[key]);

            }
          } else {
            return p;
          }



        }, new HttpParams()
        );

    }


    params = params.set('expand', '' + 'expansionSet:DOCUMENTS_OF_PROJECT');

    /*
    if (this.windowHash) {
      this.updateActiveFilters();
    }

  */

    return params;
  }

  updateActiveFilters() {
    let params = [];
    Object.getOwnPropertyNames(this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters).forEach(key => {
      let value = this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[key];
      if (value != undefined && value != '') {
        let label = this.translate.instant('DocumentsSearch.' + key);
        if (Array.isArray(value)) {
          params.push({ 'label': label, 'key': key, 'value': value });
        } else if (value.identifier) {
          let desc = value.description;
          if (!desc && value.person) {
            desc = value.person.fullName;
          }
          if (!desc) {
            desc = value.name;
          }
          params.push({ 'label': label, 'key': key, 'value': desc });
        } else if (value instanceof Date) {
          // return p.set(key, '' + value.getTime());
          params.push({ 'label': label, 'key': key, 'value': this.datePipe.transform(value, this.DATEPIPE_DATE_FORMAT) });
        } else {
          params.push({ 'label': label, 'key': key, 'value': value });
        }
      }
    });
    // this.numFilters = params.length;
    this.activeFilters = params;
  }

  removeFilter(filter) {
    console.log('REMOVING FILTER', filter);
    /*
          let checkFilters = {
            avoidTemporaryDocs: false,
            includeCancelled: false,
            ignoreNotifications: false
          }
       // Se comprueba los filtros tipo check, desmarcados tienen valor undefined
          // undefined = false*/
    if (filter.key === 'avoidTemporaryDocs' || filter.key === 'includeCancelled' || filter.key === 'ignoreNotifications') {
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[filter.key] = false;
    } else {
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._filters[filter.key] = undefined;
    }


    this.loadDocuments();
  }

  private applyClientFilters(documents: any[]): any[] {
    console.log(this.clientFilters);
    if (this.clientFilters && this.clientFilters.stateId) {
      documents = documents.filter(
        (d) =>
          d.currentState && d.currentState.type
          && d.currentState.type.identifier === this.clientFilters.stateId.identifier);
    }
    if (this.clientFilters && this.clientFilters.userStateId) {
      documents = documents.filter(
        (d) => d.user && d.user.identifier
          && d.user.identifier === this.clientFilters.userStateId.identifier);
    }
    // FECHA DE MODIFICACION
    if (this.clientFilters && this.clientFilters.stateFrom) {
      documents = documents.filter(
        (d) => d.date && d.date > this.clientFilters.stateFrom);
    }
    if (this.clientFilters && this.clientFilters.stateTo) {
      let stateTo = new Date(this.clientFilters.stateTo);
      stateTo.setDate(stateTo.getDate() + 1);

      documents = documents.filter(
        (d) => d.date && d.date < stateTo);
    }
    // FECHA DE CREACION
    if (this.clientFilters && this.clientFilters.creationDateFrom) {
      documents = documents.filter(
        (d) => d.creationDate && d.creationDate > this.clientFilters.creationDateFrom);
    }
    if (this.clientFilters && this.clientFilters.creationDateTo) {
      let dateTo = new Date(this.clientFilters.creationDateTo);
      dateTo.setDate(dateTo.getDate() + 1);

      documents = documents.filter(
        (d) => d.creationDate && d.creationDate < dateTo);
    }

    if (this.clientFilters && this.clientFilters.userSignatureId) {
      documents = documents.filter(
        (d) =>
          d.currentState && d.currentState.type
          && d.currentState.type.identifier === '52<>TIPOESTADO'
        // &&       d.currentState && d.currentState.type && d.currentState.user.identifier ===
        // this.clientFilters.userSignatureId.identifier
      );
    }


    if (this.clientFilters && this.clientFilters.signatureFrom) {
      documents = documents.filter(
        (d) =>
          d.currentState && d.currentState.type && d.currentState.type.identifier === '52<>TIPOESTADO'
          && d.currentState && d.currentState.date && d.currentState.date > this.clientFilters.signatureFrom
      );
    }

    if (this.clientFilters && this.clientFilters.signatureTo) {
      documents = documents.filter(
        (d) =>
          d.currentState && d.currentState.type && d.currentState.type.identifier === '52<>TIPOESTADO'
          && d.currentState && d.currentState.date && d.currentState.date < this.clientFilters.signatureTo
      );
    }


    return documents;
  }

  onCloseColumnSelector() {
    this.selectColumnsVisible = false;
    this._colsCodes = this.visibleColumns.map(element => element.code);
    this.userPrefs.documentsViewPrefs.visibleColumns = this.visibleColumns;
  }

  saveNodeStatus(event: any) {
    console.log(event);
    if (event.node.expanded) {
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._expandedNodes.push(event.node.NODEID);
    } else {
      this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._expandedNodes =
        this.userPrefs.documentsViewPrefs.prefs.get(this.dossierId)._expandedNodes
          .filter(item => item !== event.node.NODEID)
    }
  }

  public getClass(column: string): string {
    return this.orderColum == column ? 'text-primary' : '';
  }

  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }

  public updateCorrectDocumentAction(items: MenuItem[]): Observable<MenuItem[]> {
    if (items &&
      (getSimpleIdentifierFromString(this.dossier?.modoTramitacion?.identifier) !== MANUALPROCESSINGMODE_ID
        && this.selectCorrectProcedure)) {
      const correctAction = items.find((action: MenuItem) => action.state?.action?.identifier === 'CORRECT_DOCUMENT')
      if (correctAction) {
        // tramitacion manual ejecuta accion, y en el resto de tipos de tramitacion depende de propiedad de configuracion
        correctAction.command = () => this.createProcedure(correctAction.state?.dto)
      }
    }
    return of(items);
  }
  isSearching(): boolean {
    return this.searching;
  }
}
